module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder-boxes"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n                    " + _vm._s(_vm.title) + " Content box\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n                    " + _vm._s(_vm.title) + " Content box\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n                    " + _vm._s(_vm.title) + " Content box\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49eae5b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/placeholder-boxes.vue
// module id = 286
// module chunks = 1